import api from "ApiClient";
import { Button, Tooltip } from "antd";
import { useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "redux/hooks";
import { ApiURL, getEnabled } from "utils/Actions";
import { uacSummaryReportCSVHeaders, utasSummaryReportCSVHeaders } from "utils/AssetsData";
import { WHITELABEL } from "utils/Constants";

type CSVLinkButtonProps = {
  isStudentEmpty: boolean;
};

const CSVLinkButton = ({ isStudentEmpty }: CSVLinkButtonProps) => {
  const { t } = useTranslation();
  const whitelabel = useAppSelector(state => state.properties.whiteLabel);
  const { env } = useAppSelector(state => state.globalUI);
  const [csvData, setCsvData] = useState<any>([]);
  const [csvLoading, setCSVLoading] = useState(false);

  const csvLinkEl = useRef<any>(null);

  useEffect(() => {
    if (!csvLoading || csvData.length > 0) {
      return;
    }
    const enabled = getEnabled(env, whitelabel);
    if (!enabled) {
      return;
    }
    api
      .get(
        ApiURL.getSrsApplicantsSummaryData,
        env
          ? {
              params: {
                source: env
              }
            }
          : undefined
      )
      .then(res => {
        setCsvData(res.data.data);
      })
      .catch(error => {
        console.error(error);
      });
  }, [csvLoading, env, whitelabel]);

  useEffect(() => {
    if (csvData.length > 0 && csvLoading) {
      csvLinkEl.current.link.click();
      setCSVLoading(false);
      setCsvData([]);
    }
  }, [csvData]);

  const columnHeaders =
    whitelabel === WHITELABEL.utas ? utasSummaryReportCSVHeaders : uacSummaryReportCSVHeaders;

  return (
    <div>
      <Tooltip
        title={t("srsSummaryReport.noApplicantsTooltip")}
        trigger={isStudentEmpty ? ["hover", "focus"] : []}
        placement="bottom"
      >
        <Button
          disabled={isStudentEmpty}
          type="primary"
          onClick={() => {
            if (!csvLoading && csvData.length === 0) {
              setCSVLoading(true);
            }
          }}
        >
          {t("srsSummaryReport.csvBtn")}
        </Button>

        <CSVLink
          data={csvData}
          headers={columnHeaders}
          filename={`${t("srsSummaryReport.reportTitle")}.csv`}
          aria-label="Export as CSV file for summary report"
          ref={csvLinkEl}
        />
      </Tooltip>
    </div>
  );
};

export default CSVLinkButton;
